<template>
  <div class="fip-preview-disponibility">
    <div class="date">
      <div
        v-if="isAvailableSoonForVod"
        data-wptv="fip-vod-availability-date">
        {{ $t('fip.availableSoonForVod', { date: $options.filters.conversionDateTimestamp(item.availabilityDate) }) }}
      </div>
      <div
        v-if="isProspect && item.releaseDate"
        data-wptv="fip-theater-release-date">
        {{ $t('fip.releasedToTheaters', { date: $options.filters.convertDateYmdToDmy(item.releaseDate) }) }}
      </div>
    </div>
    <div
      v-if="item.type !== 'SEASON'"
      class="disponibility-info">
      <div
        v-if="visionnage"
        data-wptv="fip-visionnage">
        {{ $t(`fip.${item.type}`) | capitalizeFLetter }} {{ $t('fip.visionnageNOk') }}
      </div>
      <div v-if="locationExpired" class="warning">
        {{ $t('fip.locationExpired') }}
      </div>
      <div
        v-if="showVisionnageDuration">
        {{ $t('fip.visionnage') }}
        <span
          v-if="remainingTime"
          class="warning"
          data-wptv="fip-remaining-time">
          {{ $t('fip.disponibilite', getRemainingTime(remainingTime)) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import FipUtils from '../fip.utils'
import _isEmpty from 'lodash/isEmpty'
import _get from 'lodash/get'
import { mapGetters } from 'vuex'

export default {
  name: 'FipInformations',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      terminalModel: 'terminals/getTerminalModel'
    }),
    visionnage () {
      const eligibleTerminalModels = _get(this.item, 'eligibleTerminalModels', []).includes(this.terminalModel)
      const hasDefinition = !_isEmpty(this.item.definitions)
      return !eligibleTerminalModels && hasDefinition
    },
    locationExpired () {
      return FipUtils.isLocationExpired(this.$store, this.item.id)
    },
    showVisionnageDuration () {
      return this.item && this.item.orderInfo
    },
    remainingTime () {
      return _get(this.item, 'orderInfo.usage') === 'RENT' ? _get(this.item, 'orderInfo.maxWatchingDate', null) : null
    },
    isProspect () {
      return FipUtils.isProgramProspected(this.item)
    },
    isAvailableSoonForVod () {
      return this.isProspect &&
        !!this.item.availabilityDate &&
        this.item.availabilityDate > 0
    }
  },
  methods: {
    getRemainingTime (remainingTime) {
      return {
        date: this.$options.filters.conversionDateTimestamp(remainingTime),
        heure: this.$options.filters.conversionHourTimestamp(remainingTime)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.date {
  font-weight: bold;
  margin-top: 10px;
}
.fip-preview-disponibility {
  color: inherit;
  font-family: inherit;
  font-weight: normal;
  @include mediaQueries('margin-top', (large: 10px, xlarge: 15px));
  @include mediaQueries('font-size', (large: 14px, xlarge: 16px));
  @include mediaQueries('line-height', (large: 20px, xlarge: 22px));

  .disponibility-info {
    font-weight: bold;

    .warning {
      color: $primary;
    }
  }
}
</style>
